<template>
  <b-alert
    show
    :class="[
      'm-0 w-100',
      $style.alert,
      isCenter && 'd-flex flex-column',
    ]"
    :variant="variant"
  >
    <font-awesome-icon
      icon="exclamation-triangle"
      :size="isCenter ? '2x' : 'lg'"
      :class="$style.icon"
    />
    <div
      :class="[
        isCenter && 'pt-4 text-center',
        $style.content
      ]"
    >
      <slot />
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'BaseAlert',
  props: {
    variant: {
      type: String,
      default: 'warning',
    },
    isCenter: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style lang="scss" module>
  .alert {
    border-radius: 0 !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem 1rem !important;
    .content {
      padding-left: 1rem;
    }
    .icon {
      opacity: .85;
    }
  }
</style>
